import { render, staticRenderFns } from "./TareasByUser.vue?vue&type=template&id=2b87a8ec&scoped=true"
import script from "./TareasByUser.vue?vue&type=script&lang=js"
export * from "./TareasByUser.vue?vue&type=script&lang=js"
import style0 from "./TareasByUser.vue?vue&type=style&index=0&id=2b87a8ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b87a8ec",
  null
  
)

export default component.exports